/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Camera_Settings_Card_DescInputs */

const vi_grower_camera_settings_card_desc = /** @type {(inputs: Grower_Camera_Settings_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản dùng chung cho mọi camera vùng trồng. Đường dẫn từng camera nhập ở trang hộ trồng.`)
};

/**

* @param {Grower_Camera_Settings_Card_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_camera_settings_card_desc = /** @type {((inputs?: Grower_Camera_Settings_Card_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Camera_Settings_Card_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_camera_settings_card_desc(inputs)
});